import { Filter } from './filter.js';
export class AlphaSelectionFilter extends Filter {
    _color: number[];

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'alphaSelection', 'Selection vers alpha');
        this.reset();
        this._layerVisible = false;
    }

    get color() {
        return this._color;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._color = [0, 0, 0, 0];
    }

}
